import { USER_AREAS_ARRAY } from 'src/constants/user';

export const SOURCE_SERVICE_AREA = 'service';

export const SOURCE_AREAS_ARRAY = [...USER_AREAS_ARRAY, SOURCE_SERVICE_AREA];

export type TSourceAreas = (typeof SOURCE_AREAS_ARRAY)[number];
